export default{
    与我们联系:"Hãy liên hệ với chúng tôi bên dưới.",
    专属客户经理将尽快联系您:"",
    立即参与:"Gửi",
}